// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3GmxA","tab":"Tabs_tab__1MeNS","tabActive":"Tabs_tabActive__-4C6_"};